import {
  SEARCH_RESULT_CLEAR,
  SEARCH_RESULT_STARTED,
  SEARCH_RESULT_SUCCESS,
  SEARCH_RESULT_FAILURE,
  SEARCH_FILTER_SELECTION,
  SEARCH_UPDATE_SEARCH_TEXT,
  SEARCH_SUGGESTIONS_STARTED,
  SEARCH_HISTORY_STARTED,
  SEARCH_SUGGESTIONS_DONE,
  SEARCH_HISTORY_DONE,
  SEARCH_UPDATE_SORT,
  SEARCH_UPDATE_STARTED
} from "../constants/research.constant";
import { OrderType, SearchOrder } from "../constants/search.constant";

const initialState = {
  updating: 0,
  loading: false,
  searchstatus: "",
  search_results: [],
  totalResult: 0,
  totalPages: 0,
  error: null,
  searchTxt: "",
  filterOpts: {},
  selFilterOpts: {},
  suggestionInfo: { loading: false, searchList: [], history: [] },
  sortInfo: { key: SearchOrder.published, order: OrderType.desc },
};

export default function researchReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_RESULT_CLEAR:
      return {
        loading: false,
        searchstatus: "",
        search_results: [],
        totalResult: 0,
        totalPages: 0,
        error: null,
        searchTxt: "",
        filterOpts: {},
        selFilterOpts: {},
        suggestionInfo: { loading: false, searchList: [], history: [] },
        sortInfo: { key: SearchOrder.published, order: OrderType.desc },
      };
    case SEARCH_RESULT_STARTED:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_UPDATE_STARTED:
      return {
        ...state,
        updating: state.updating + 1,
      };
    case SEARCH_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        updating: (state.updating > 0) ? state.updating - 1 : 0,
        searchstatus: action.payload.status,
        search_results: action.payload.data,
        totalResult: action.payload.totalResult,
        totalPages: action.payload.totalPages,
        filterOpts: action.payload.filterOpts,
      };
    case SEARCH_RESULT_FAILURE:
      return {
        ...state,
        loading: false,
        updating: (state.updating > 0) ? state.updating - 1 : 0,
        error: action.payload.error,
        search_results: [],
      };
    case SEARCH_FILTER_SELECTION:
      return {
        ...state,
        selFilterOpts: action.payload,
      };
    case SEARCH_UPDATE_SEARCH_TEXT:
      return {
        ...state,
        searchTxt: action.payload,
      };
    case SEARCH_SUGGESTIONS_STARTED:
    case SEARCH_HISTORY_STARTED:
      return {
        ...state,
        suggestionInfo: {
          ...state.suggestionInfo,
          loading: true,
        },
      };
    case SEARCH_SUGGESTIONS_DONE:
      return {
        ...state,
        suggestionInfo: {
          ...state.suggestionInfo,
          loading: false,
          searchList: action.payload,
        },
      };
    case SEARCH_HISTORY_DONE:
      return {
        ...state,
        suggestionInfo: {
          ...state.suggestionInfo,
          loading: false,
          history: action.payload,
        },
      };
    case SEARCH_UPDATE_SORT:
      return {
        ...state,
        sortInfo: action.payload,
      };
    default:
      return state;
  }
}
